import { Component } from '@angular/core';
import { ApplicationFilesService } from '../../shared/services/application-files.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ins-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  enableCustomerPortal = environment.EnableCustomerPortal;

  constructor(private appFilesService: ApplicationFilesService) {}

  downloadClaimPacket(): void {
    this.appFilesService.downloadFile('Claim Forms\\Claim Packet.pdf');
  }

  downloadPrivacyPolicy(): void {
    this.appFilesService.downloadFile(
      'Legal Documents\\Privacy Policy DAC.pdf',
    );
  }

  downloadTermsOfUse(): void {
    this.appFilesService.downloadFile('Legal Documents\\Terms of Use DAC.pdf');
  }
}
